import { render, staticRenderFns } from "./NewAutoplugModal.vue?vue&type=template&id=480d6e94&"
import script from "./NewAutoplugModal.vue?vue&type=script&lang=js&"
export * from "./NewAutoplugModal.vue?vue&type=script&lang=js&"
import style0 from "./NewAutoplugModal.vue?vue&type=style&index=0&id=480d6e94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports